import styled from "styled-components";
import { Colors } from '../../styles/consts'

export const LogoNameContainer = styled.div`

display: flex;
align-items: center;

cursor: pointer;
`

export const LogoImage = styled.img`
width: 30px;
margin-right: 5px;
`;

export const AppName = styled.h1`
color: ${Colors.PRIMARY_COLOR_FONT};
`;

